import {
  getInitialFilterState,
  getInitialListingPageState,
} from 'pages/merchant/dashboard/payout/listing/initialStates';
import { IListingPagePropsObj, IPayoutFilterObj } from 'pages/merchant/dashboard/payout/listing/types';
import {
  getPayoutBreakdownInitialFilterState,
  getPayoutBreakdownInitialPageState,
} from 'pages/merchant/dashboard/payout/payout-breakdown-listing/initialStates';
import {
  IPayoutBreakdownFilterObj,
  IPayoutBreakdownPageObj,
} from 'pages/merchant/dashboard/payout/payout-breakdown-listing/types';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface IConfig {
  payoutFilterObj: IPayoutFilterObj;
  listingPageProps: IListingPagePropsObj;
  payoutBreakdownFilterObj: IPayoutBreakdownFilterObj;
  payoutBreakdownPageObj: IPayoutBreakdownPageObj;
}

const initialState: IConfig = {
  payoutFilterObj: getInitialFilterState(),
  listingPageProps: getInitialListingPageState(),
  payoutBreakdownFilterObj: getPayoutBreakdownInitialFilterState(),
  payoutBreakdownPageObj: getPayoutBreakdownInitialPageState(),
};

export const payoutSlice = createSlice({
  name: 'payoutConfig',
  initialState,
  reducers: {
    setPayoutFilterObj: (state, action: PayloadAction<IPayoutFilterObj>) => {
      state.payoutFilterObj = action.payload;
    },
    setListingPagePropsObj: (state, action: PayloadAction<IListingPagePropsObj>) => {
      state.listingPageProps = action.payload;
    },
    setPayoutBreakdownFilterObj: (state, action: PayloadAction<IPayoutBreakdownFilterObj>) => {
      state.payoutBreakdownFilterObj = action.payload;
    },
    setPayoutBreakdownPageObj: (state, action: PayloadAction<IPayoutBreakdownPageObj>) => {
      state.payoutBreakdownPageObj = action.payload;
    },
  },
});

export const { setPayoutFilterObj, setListingPagePropsObj, setPayoutBreakdownFilterObj, setPayoutBreakdownPageObj } =
  payoutSlice.actions;

export default payoutSlice.reducer;
